(() => {
  'use strict';

  function showError(wrapper, message) {
    const error = wrapper.querySelector('[data-zvg-error]');
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
  }

  async function addItems(items, wrapper, button) {
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const error = wrapper.querySelector('[data-zvg-error]');
    if (error) error.hidden = true;

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      const body = await response.json();
      if (!response.ok) throw new Error(body.description || body.message || 'Could not add these items to the cart.');
      window.location.assign(`${window.Shopify.routes.root}cart`);
    } catch (errorMessage) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      showError(wrapper, errorMessage.message);
    }
  }

  document.addEventListener('click', event => {
    const quantityButton = event.target.closest('[data-zvg-quantity-change]');
    if (quantityButton) {
      const wrapper = quantityButton.closest('[data-zvg-atc]');
      const input = wrapper && wrapper.querySelector('[data-zvg-quantity]');
      if (!input) return;
      const delta = Number(quantityButton.dataset.zvgQuantityChange);
      input.value = Math.min(10, Math.max(1, Number(input.value || 1) + delta));
      return;
    }

    const vipButton = event.target.closest('[data-zvg-vip-add]');
    if (vipButton) {
      const wrapper = vipButton.closest('[data-zvg-atc]');
      const productVariant = Number(wrapper.dataset.productVariant);
      const membershipVariant = Number(wrapper.dataset.membershipVariant);
      const quantity = Number(wrapper.querySelector('[data-zvg-quantity]')?.value || 1);
      if (!productVariant || !membershipVariant) {
        showError(wrapper, 'The VIP product or current product variant is not configured.');
        return;
      }
      addItems([
        { id: productVariant, quantity },
        { id: membershipVariant, quantity: 1, properties: { 'Membership type': 'VIP membership' } },
      ], wrapper, vipButton);
    }
  });
})();

(() => {
  'use strict';
  const root = document.querySelector('[data-zvg-variants]');
  if (!root) return;
  let variants = [];
  try { variants = JSON.parse(root.querySelector('[data-zvg-variant-map]').textContent); } catch (e) { return; }
  const fieldsets = [...root.querySelectorAll('.zvg-option')];
  const section = root.closest('.zvg-pdp__details') || document;

  function selected() {
    return fieldsets.map(f => { const c = f.querySelector('input:checked'); return c ? c.value : null; });
  }
  function findVariant(opts) {
    return variants.find(v => opts.every((o, i) => v.options[i] === o));
  }
  function apply(variant) {
    if (!variant) return;
    section.querySelectorAll('input[name="id"]').forEach(i => { i.value = variant.id; });
    section.querySelectorAll('[data-zvg-atc]').forEach(w => { w.dataset.productVariant = variant.id; });
    const price = section.querySelector('.zvg-pdp__price strong');
    if (price && window.Shopify && window.Shopify.formatMoney) price.textContent = window.Shopify.formatMoney(variant.price);
    section.querySelectorAll('.zvg-atc__button[type="submit"]').forEach(b => {
      b.disabled = !variant.available;
      if (!variant.available) b.textContent = 'Sold out';
    });
    const status = section.querySelector('.zvg-pdp__status span:first-child');
    if (status) status.textContent = variant.available ? 'In stock' : 'Sold out';
    const sku = section.querySelector('.zvg-pdp__status span:last-child');
    if (sku && variant.sku) sku.textContent = 'SKU ' + variant.sku;
    try { const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); } catch (e) {}
  }
  function refreshAvailability() {
    const opts = selected();
    fieldsets.forEach((f, idx) => {
      f.querySelectorAll('input').forEach(inp => {
        const test = opts.slice(); test[idx] = inp.value;
        const v = findVariant(test);
        inp.closest('.zvg-pill').classList.toggle('is-unavailable', !v || !v.available);
      });
      const label = f.querySelector('[data-zvg-option-selected]');
      if (label) label.textContent = opts[idx] || '';
    });
  }
  root.addEventListener('change', () => { refreshAvailability(); apply(findVariant(selected())); });
  refreshAvailability();
})();
